import TagManager from 'react-gtm-module';
import Cookies from 'universal-cookie';
import StorageService from 'services/StorageService'
import { Analytics } from 'services/PushNotification'
import PersonalizeService from 'services/Personalize'
import VtexEvent from 'services/VtexEvent'

const init = () => {
    TagManager.initialize({
        gtmId: 'GTM-5WWDCL8'
    });
    const cookies = new Cookies();

    cookies.set('source', 'react-app', { path: '/', domain: '.jumbo.cl', secure: !PROJECT_ENV.authDevelopment });

    userId();
}

const __setDataLayer = (data) => {
    TagManager.dataLayer({
        dataLayer: data
    });

    const event = {
        'ecommerce': void 0
    }

    TagManager.dataLayer({
        dataLayer: event
    });
}

const userId = () => {
    const data = StorageService.getSecureItem('userData');
    if(!(data && data.gtmSegment)) return false;

    __setDataLayer({'userId': data.gtmSegment , 'dimension25': data.CencoPrime_2020 ? "prime" : "normal" });
    Analytics.setUserId(data.gtmSegment);
}

const productImpressions = (products, list = '') => {
    try {
        products = products.map((product, i) => {
            const item = product.items[0];

            return {
                'name': product.productName,
                'id': item.itemId,
                'refId': item.referenceId[0].Value,
                'price': item.prices.regular,
                'brand': product.brand,
                'category': product.categories[0] || '',
                'variant': '',
                'list': list,
                'position': (product.pos || product.pos === 0) ? product.pos : i,
            }
        });

        const event = {
            'event': 'impressions',
            'ecommerce': {
                'currencyCode': 'CLP',
                'impressions': products,
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const emptyImpressions = () => {
    try {
        const event = {
            'event': 'impressions',
            'ecommerce': {
                'currencyCode': 'CLP',
                'impressions': [],
            },
        };
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const listImpressions = (products, list) => {

    try {
        products = products.map((product, i) => {
            const item = product.items ? product.items[0] : null;
            return {
                'name': product.productName || product.ProductName,
                'id': item ? item.itemId : product.Id,
                'refId': item ? item.referenceId[0].Value : '',
                'price': item ? item.prices.regular : 0,
                'brand': product.brand || product.BrandName,
                'category': item ? product.categories[0] || '' : '',
                'list': 'Lista Personalizada: ' + list,
                'position': product.pos ? product.pos : i,
            }
        });

        const event = {
            'event': 'impressions',
            'ecommerce': {
                'currencyCode': 'CLP',
                'impressions': products,
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }

}

const productClick = (product, list, position = 0) => {
    try {
        const item = product.items ? product.items[0] : null;

        if(list.indexOf('Búsqueda:') !== -1 && item && item.itemId) VtexEvent.click(item.itemId, list.replace('Búsqueda: ', ''));

        const event = {
            'event': 'productClick',
            'ecommerce': {
                'currencyCode': 'CLP',
                'click': {
                    'actionField': { 'list': list },
                    'products': [{
                        'name': product.productName || product.ProductName,
                        'id': item ? item.itemId : product.Id,
                        'refId': item ? item.referenceId[0].Value : '',
                        'price': item ? item.prices.regular : 0,
                        'brand': product.brand || product.BrandName,
                        'category': item ? product.categories[0] || '' : '',
                        'variant': '',
                        'position': position
                    }]
                }
            }
        }

        __setDataLayer(event);

    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }

}

const productClickList = (products, listName, position = 0) => {

    try {
        let prod = [];
        products.map(product => {
            const item = product.items ? product.items[0] : null;
            prod.push({
                'name': product.productName || product.ProductName,
                'id': item ? item.itemId : product.Id,
                'refId': item ? item.referenceId[0].Value : '',
                'price': item ? item.prices.regular : 0,
                'brand': product.brand || product.BrandName,
                'category': item ? product.categories[0] || '' : '',
                'variant': '',
                'position': product.pos ? product.pos : position
            })
        })

        const event = {
            'event': 'productClick',
            'ecommerce': {
                'click': {
                    'actionField': { 'list': listName },
                    'products': prod
                }
            },
        };
        __setDataLayer(event);

    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }

}

const productClickCart = (product, list = '', position = 0, price = 0) => {
    let category = product.productCategories ? Object.values(product.productCategories) : '';

    try {
        const event = {
            'event': 'productClick',
            'ecommerce': {
                'click': {
                    'actionField': { 'list': list },
                    'products': [{
                        'name': product.name,
                        'id': product.id,
                        'refId': product.refId || product.productRefId,
                        'price': price,
                        'brand': product.additionalInfo.brandName || product.additionalInfo,
                        'category': "/" + category.toString().replace(",", "/").toLocaleLowerCase() + "/" || '',
                        'variant': '',
                        'position': position
                    }]
                }
            },
        };
        __setDataLayer(event);

    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }

}

const productDetail = (product, list) => {
    try {
        const item = product.items[0];
        const event = {
            'event': 'productDetail',
            'ecommerce': {
                'currencyCode': 'CLP',
                'detail': {
                    "actionField" : {
                        "list": list ? list : '',
                    },
                    'products': [{
                        'name': product.productName,
                        'id': item.itemId,
                        'refId': item.referenceId[0].Value,
                        'price': item.prices.regular,
                        'brand': product.brand,
                        'category': product.categories[0] || '',
                        'variant': ''
                    }]
                }
            },
        };
        __setDataLayer(event);
        PersonalizeService.preview(item)
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const addToCart = (product, quantity) => {
    try {
        const item = product.items[0];
        const orderFormId = StorageService.getItem('orderFormId');
        const event = {
            'event': 'addToCart',
            'ecommerce': {
                'cartId' : orderFormId,
                'currencyCode': 'CLP',
                'add': {
                    'products': [{
                        'name': product.productName,
                        'id': item.itemId,
                        'refId': item.referenceId[0].Value,
                        'price': item.prices.regular,
                        'brand': product.brand,
                        'category': product.categories[0] || '',
                        'variant': '',
                        'quantity': quantity

                    }]
                }
            }
        }
        __setDataLayer(event);
        PersonalizeService.addToCart([{...item, quantity}]);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const addProductListToCart = (products) => {
    try {
        let prod = products.map((product, i) => {
            const item = product.items[0];

            return {
                'name': product.productName,
                'id': item.itemId,
                'refId': item.referenceId[0].Value,
                'price': item.prices.regular,
                'brand': product.brand,
                'category': product.categories[0] || '',
                'variant': '',
                'position': product.pos ? product.pos : i,
                'quantity': product.quantity
            }
        });
        const orderFormId = StorageService.getItem('orderFormId');

        const event = {
            'event': 'addToCart',
            'ecommerce': {
                'cartId' : orderFormId,
                'currencyCode': 'CLP',
                'add': {
                    'products': prod
                }
            }
        }
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const removeCart = (product, price) => {
    try {
        const orderFormId = StorageService.getItem('orderFormId');
        const event = {
            'event': 'removeFromCart',
            'ecommerce': {
                'cartId' : orderFormId,
                'currencyCode': 'CLP',
                'remove': {
                    'products': [{
                        'name': product.name,
                        'id': product.id,
                        'refId': product.refId || product.productRefId,
                        'price': price,
                        'brand': product.additionalInfo.brandName || product.additionalInfo,
                        'variant': '',
                        'quantity': product.quantity

                    }]
                }
            }
        }
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const removeAllItemsCart = (products) => {

    try {
        let prod = [];
        products.map(product => {
            prod.push({
                'name': product.name,
                'id': product.id,
                'refId': product.refId || product.productRefId,
                'price': product.price,
                'brand': product.additionalInfo.brandName || product.additionalInfo,
                'variant': '',
                'quantity': product.quantity
            });
            return true;
        })

        const orderFormId = StorageService.getItem('orderFormId');
        const event = {
            'event': 'removeFromCart',
            'ecommerce': {
                'cartId' : orderFormId,
                'currencyCode': 'CLP',
                'remove': {
                    'products': prod
                }
            }
        }
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const removeItemsModalChangeSalesChannel = (products, quantity) => {
    try {
        let prod = [];
        products.map(product => {
            prod.push({
                'name': product.items[0].name,
                'id': product.items[0].itemId,
                'refId': product.items[0].referenceId[0].Value,
                'price': product.items[0].prices.regular,
                'brand': product.brand,
                'variant': '',
                'quantity': quantity
            });
            return true;
        })

        const orderFormId = StorageService.getItem('orderFormId');
        const event = {
            'event': 'removeFromCart',
            'ecommerce': {
                'cartId' : orderFormId,
                'currencyCode': 'CLP',
                'remove': {
                    'products': prod
                }
            }
        }
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const miniQtyAdd = (product, quantity, price) => {
    let category = product.productCategories ? Object.values(product.productCategories) : '';

    try {
        const orderFormId = StorageService.getItem('orderFormId');
        const event = {
            'event': 'addToCart',
            'ecommerce': {
                'cartId' : orderFormId,
                'currencyCode': 'CLP',
                'add': {
                    'products': [{
                        'name': product.name,
                        'id': product.id,
                        'refId': product.refId || product.productRefId,
                        'price': price,
                        'brand': product.additionalInfo.brandName || product.additionalInfo,
                        'category': "/" + category.toString().replace(",", "/").toLocaleLowerCase() + "/" || '',
                        'variant': '',
                        'quantity': quantity

                    }]
                }
            }
        }
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const miniQtyRemove = (product, quantity, price) => {
    let category = product.productCategories ? Object.values(product.productCategories) : '';

    try {
        const orderFormId = StorageService.getItem('orderFormId');
        const event = {
            'event': 'removeFromCart',
            'ecommerce': {
                'cartId' : orderFormId,
                'currencyCode': 'CLP',
                'remove': {
                    'products': [{
                        'name': product.name,
                        'id': product.id,
                        'refId': product.refId || product.productRefId,
                        'price': price,
                        'brand': product.additionalInfo.brandName || product.additionalInfo,
                        'category': "/" + category.toString().replace(",", "/").toLocaleLowerCase() + "/" || '',
                        'variant': '',
                        'quantity': quantity

                    }]
                }
            }
        }
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}


const promotionsImpressions = (items) => {
    try {
        let promotions = [];
        promotions = items.map(item => {

            return {
                id: item.id,
                name: item.name,
                creative: item.creative,
                position: item.position
            };
        });

        const event = {
            'event': 'promotionsView',
            'ecommerce': {
                'promoView': {
                    'promotions': promotions
                }
            }
        }
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const promotionsClick = (item, position = false, creative = false) => {
    try {
        const event = {
            'event': 'promotionClick',
            'ecommerce': {
                'promoClick': {
                    'promotions': [
                        {
                            id: item.id,
                            name: item.name || item.title || item.title_box,
                            creative: item.creative ? item.creative : creative,
                            position: item.position ? item.position : position
                        }
                    ]
                }
            }
        }
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const changePage= () => {
    try {
        const event = {
            'event': 'PageviewVirtual'
        };
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const interaction = (action, tag, category = false) => {
    try {
        const event = {
            'event': 'Interaction',
            'category': category ? category : 'Filtro Ordenación',
            'actions': action,
            'tag': tag
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const checkoutOption = (step, option) => {
    try {
        const event = {
            'event': 'checkoutOption',
            'ecommerce': {
                'checkout_option': {
                    'actionField': { 'step': step, 'option': option }
                },
            }
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const createList = (action, tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Listas',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const deleteList = (action, tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Listas',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const editList = (action, tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Listas',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const addList = (action, tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Listas',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const buySelectedList = (action, tag) => {
    //falta aplicar
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Listas',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const saveList = (action, tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Listas',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const menu = (action, tag, origin) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': origin,
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const filterMenu = (action, tag, origin) => {
    try {
        const event = {
            'event': 'Interaction',
            'category': origin,
            'actions': action,
            'tag': tag
        }

        __setDataLayer(event);

    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const cleanFilterMenu = (action, tag, origin) => {
    try {
        const event = {
            'event': 'Interaction',
            'category': origin,
            'actions': action,
            'tag': tag
        }

        __setDataLayer(event);

    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const clickHeader = (action, tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Header Top',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const clickSearch = (action, tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Ver todos los resultados',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const clickLink = (action, tag, category) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': category,
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const changeDeliveryMode = (tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Metodo de entrega',
                'actions': 'Cambio',
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const clickEntryOrRegister = (action, tag) => {
    try {
        const event = {
            'event': 'Metodo de entrega',
            'ecommerce': {
                'category': 'Metodo de entrega',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const receiveHome = (tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Metodo de entrega',
                'actions': 'Despacho Agendado',
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const receiveHomeNewAddress = (tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Registra nueva dirección',
                'actions': 'Mapa',
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const receiveHomeNew = (tag) => {
    //es similar al primero
    try {
        const event = {
            'event': 'Metodo de entrega',
            'ecommerce': {
                'category': 'Metodo de entrega',
                'actions': 'Despacho Agendado',
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const logAccount = (category, action, tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': category,
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const registerAccount = (category, action, tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': category,
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const homeBody = (action, tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Home-body',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const suscribe = (action, tag) => {
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Suscribir',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const footer = (action, tag) => {
    //falta aplicar
    try {
        const event = {
            'event': 'Interaction',
            'ecommerce': {
                'category': 'Footer',
                'actions': action,
                'tag': tag
            },
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const onCheckout = (products, step, option, typeDelivery = false) => {

    if (typeDelivery) {
        try {
            products = products.map((item) => {
                let category = item.productCategories ? Object.values(item.productCategories) : '';

                return {
                    'name': item.name,
                    'id': item.id,
                    'refId':item.refId,
                    'price': item.price,
                    'brand': item.additionalInfo.brandName || item.additionalInfo,
                    'category': "/" + category.toString().replace(",", "/").toLocaleLowerCase() + "/" || '',
                    'variant': '',
                    'quantity': item.quantity
                }
            });
            const orderFormId = StorageService.getItem('orderFormId');
            const event = {
                'event': 'checkout',
                'ecommerce': {
                    'cartId' : orderFormId,
                    'checkout': {
                        'actionField': { 'step': step, 'option': option.replace(/ *\([^)]*\) */g, "") },
                        'products': products,
                    }
                },
            };
            __setDataLayer(event);

        } catch (error) {
            /* eslint-disable no-console */
            console.log('TagManagerService Error');
        }
    } else {
        try {
            products = products.map((item) => {
                let category = item.productCategories ? Object.values(item.productCategories) : '';

                return {
                    'name': item.name,
                    'id': item.id,
                    'refId': item.refId,
                    'price': item.price,
                    'brand': item.additionalInfo.brandName || item.additionalInfo,
                    'category': "/" + category.toString().replace(",", "/").toLocaleLowerCase() + "/" || '',
                    'variant': '',
                    'quantity': item.quantity
                }
            });
            const orderFormId = StorageService.getItem('orderFormId');
            const event = {
                'event': 'checkout',
                'ecommerce': {
                    'cartId' : orderFormId,
                    'checkout': {
                        'actionField': { 'step': step },
                        'products': products,
                    }
                },
            };
            __setDataLayer(event);

        } catch (error) {
            /* eslint-disable no-console */
            console.log('TagManagerService Error');
        }
    }
}

const onCheckoutOption = (actionField) => {
    try {
        const event = {
            'event': 'checkoutOption',
            'ecommerce': {
                'checkout_option': {
                    'actionField': actionField
                }
            }
        }
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const pageResume = (products, step) => {
    try {
        products = products.map((product) => {
            return {
                'name': product.name,
                'id': product.id,
                'refId': product.refId,
                'price': (product.sellingPrice / 100),
                'brand': product.additionalInfo.brandName,
                'category': product.additionalInfo.categoriesIds,
                'variant': '',
                'quantity': product.quantity
            }
        });
        const orderFormId = StorageService.getItem('orderFormId');
        const event = {
            'event': 'checkout',
            'ecommerce': {
                'cartId' : orderFormId,
                'checkout': {
                    'actionField': { 'step': step },
                    'products': products,
                }
            },
        };

        __setDataLayer(event);

    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const purchase = (products, purchaseData) => {
    try {
        const newProducts = products.map((product) => {
            return {
                'id': product.id,
                'refId': product.refId,
                'price': (product.sellingPrice / 100),
                'quantity': product.quantity
            }
        });

        const orderFormId = StorageService.getItem('orderFormId');
        const event = {
            'event': 'purchase',
            'ecommerce': {
                'cartId' : orderFormId,
                'purchase': {
                    'actionField': {
                        'id': purchaseData.id,
                        'afiliation': purchaseData.afiliation,
                        'revenue': purchaseData.revenue,
                        'tax': purchaseData.tax,
                        'shipping': purchaseData.shipping,
                        'coupon': purchaseData.coupon
                    },
                    'products': newProducts,
                }
            },
        };

        __setDataLayer(event);
        PersonalizeService.purchase(purchaseData.id, products)

    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const _homeProductImpressions = (products) => {
    try {
        const event = {
            'event': 'impressions',
            'ecommerce': {
                'currencyCode': 'CLP',
                'impressions': products,
            },
        };
        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const offeredWindow = (actions,tag, sc,nameMethod) => {
    try {
        const event = {
            'event': 'Interaction',         
            'category': 'Ventana despacho Inicial',
            'actions': actions, 
            'tag': tag,
            'dimension27': sc,
            'dimension28': nameMethod
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error');
    }
}

const checkoutWindows = (first, selected, sc,nameMethod) => {

    try {
        const event = {
            'event': 'Interaction',
            'category': 'Ventana despacho Compra',
            'actions': selected.startDateUtc, 
            'tag': selected.endDateUtc,
            'dimension27': sc,
            'dimension28': nameMethod,
            'dimension29': first.startDateUtc,
            'dimension30': first.endDateUtc
        };

        __setDataLayer(event);
    } catch (error) {
        /* eslint-disable no-console */
        console.log('TagManagerService Error', error);
    }
}

let heroBanners = []
let offerBanners = []
let shortBanners = []
let jumboWorldBanners = []
let secondaryGridBanners = []
let shelfBannerSlider = []
let sliderProductsBanners = []
let impressionsPlp = []
let bannerTimer = []
let timeoutGtm = null

const gtmHome = (data) => {
    switch(data.type) {
        case 'heroBanner':
            delete data.type
            heroBanners.push(data)
            break
        case 'offerBanner':
            delete data.type
            offerBanners.push(data)
            break
        case 'shortBanner':
            delete data.type
            shortBanners.push(data)
            break
        case 'jumboWorld':
            delete data.type
            jumboWorldBanners.push(data)
            break
        case 'secondaryGridBanner':
            delete data.type
            secondaryGridBanners.push(data)
            break
        case 'shelfBannerSlider':
            delete data.type
            shelfBannerSlider.push(data)
            break
        case 'sliderProductsBanner':
            delete data.type
            sliderProductsBanners.push(data)
            break
        case 'impression-plp':
            delete data.type
            impressionsPlp.push(data)
            break
        case 'banner-timer':
            delete data.type
            bannerTimer.push(data)
            break
        default:
            break
    }

    clearTimeout(timeoutGtm)

    timeoutGtm = setTimeout(() => {
        if(heroBanners.length) {
            promotionsImpressions(heroBanners)
            heroBanners = []
        }

        if(offerBanners.length) {
            promotionsImpressions(offerBanners)
            offerBanners = []
        }

        if(shortBanners.length) {
            promotionsImpressions(shortBanners)
            shortBanners = []
        }

        if(jumboWorldBanners.length) {
            promotionsImpressions(jumboWorldBanners)
            jumboWorldBanners = []
        }

        if(secondaryGridBanners.length) {
            promotionsImpressions(secondaryGridBanners)
            secondaryGridBanners = []
        }

        if(shelfBannerSlider.length) {
            promotionsImpressions(shelfBannerSlider)
            shelfBannerSlider = []
        }

        if(sliderProductsBanners.length) {
            _homeProductImpressions(sliderProductsBanners)
            sliderProductsBanners = []
        }
        if(impressionsPlp.length) {
            _homeProductImpressions(impressionsPlp)
            impressionsPlp = []
        }
        if(bannerTimer.length) {
            promotionsImpressions(bannerTimer)
            bannerTimer = []
        }
    }, 300)
}

const TagManagerService = {
    init,
    userId,
    removeAllItemsCart,
    productImpressions,
    emptyImpressions,
    listImpressions,
    productClick,
    productClickList,
    productClickCart,
    productDetail,
    addToCart,
    addProductListToCart,
    removeCart,
    removeItemsModalChangeSalesChannel,
    miniQtyAdd,
    miniQtyRemove,
    promotionsImpressions,
    promotionsClick,
    changePage,
    interaction,
    checkoutOption,
    createList,
    deleteList,
    editList,
    addList,
    buySelectedList,
    saveList,
    menu,
    filterMenu,
    cleanFilterMenu,
    clickHeader,
    clickSearch,
    clickLink,
    changeDeliveryMode,
    clickEntryOrRegister,
    receiveHome,
    receiveHomeNewAddress,
    receiveHomeNew,
    logAccount,
    registerAccount,
    homeBody,
    suscribe,
    footer,
    onCheckout,
    onCheckoutOption,
    pageResume,
    purchase,
    gtmHome,
    offeredWindow,
    checkoutWindows
}

export default TagManagerService;
